import React from "react";
import { Link } from "react-router-dom";
import ServiceCarousel from "./ServiceCarousel";

// 🔹 Add these images into src/assets with these names
import businessLoansImg from "../assets/business-loans.png";
import businessFinanceImg from "../assets/business-finance.png";
import equipmentFinanceImg from "../assets/equipment-finance.png";

const businessServices = [
  {
    id: "business-loans",
    title: "Business Loans",
    tagline: "Business acquisition & working capital",
    description:
      "Funding to buy a business, buy into a partnership, or cover the gap between paying your suppliers and getting paid yourself.",
    image: businessLoansImg,
  },
  {
    id: "business-finance",
    title: "Business Finance",
    tagline: "Funding for growth",
    description:
      "Lending for the expensive part of expanding: another site, more staff, a bigger marketing spend. We set the repayments around when money actually comes in.",
    image: businessFinanceImg,
  },
  {
    id: "equipment-finance",
    title: "Equipment Finance",
    tagline: "Vehicle & machinery funding",
    description:
      "Finance for vehicles, plant and machinery. The asset itself usually secures the loan, so your working capital stays free for running the business.",
    image: equipmentFinanceImg,
  },
];

function BusinessServicesSection() {
  return (
    <section className="section business-services-section">
      <div className="section-header">
        <span className="section-kicker">Business</span>
        <h2 className="section-title">
          Business funding that fits your cashflow.
        </h2>
        <p className="section-subtitle">
          Banks assess business lending differently from home loans, and
          self-employed applications get declined for reasons that often have
          little to do with whether the business is sound. We’ll tell you
          where yours is likely to land before you apply.
        </p>
      </div>

      <ServiceCarousel label="Business services">
        {businessServices.map((service) => (
          <div className="business-loop-card" key={service.id}>
            <div className="business-card-image">
              <img src={service.image} alt={service.title} />
            </div>

            <div className="business-card-content">
              <div className="business-card-tag">{service.tagline}</div>
              <h3 className="business-card-title">{service.title}</h3>
              <p className="business-card-description">
                {service.description}
              </p>

              <Link
                to={`/services/${service.id}`}
                className="business-card-link"
              >
                Learn more about {service.title.toLowerCase()}
              </Link>
            </div>
          </div>
        ))}
      </ServiceCarousel>
    </section>
  );
}

export default BusinessServicesSection;
